import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH, SUPPORT_HELP_PUBLIC_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'landing',
        path: '/',
        component: React.lazy(() => import('views/public-views/vlm-landing')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'pricing-public',
        path: '/pricing',
        component: React.lazy(() => import('views/public-views/vlm-pricing')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'support-help-public',
        path: SUPPORT_HELP_PUBLIC_PATH,
        component: React.lazy(() => import('views/public-views/vlm-support-help')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'forget-reset-password',
        path: '/forget-reset-password',
        component: React.lazy(() => import('views/auth-views/authentication/reset-password')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'user-reset-password',
        path: '/user-reset-password',
        component: React.lazy(() => import('views/auth-views/authentication/reset-password')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'health',
        path: '/health',
        component: React.lazy(() => import('views/app-views/health')),
    },
    {
        key: 'payment.success',
        path: '/app/payment/success',
        component: React.lazy(() => import('views/app-views/pages/payment/success')),
    },
    {
        key: 'payment.cancel',
        path: '/app/payment/cancel',
        component: React.lazy(() => import('views/app-views/pages/payment/cancel')),
    },
    {
        key: 'payment.status',
        path: '/app/payment/status',
        component: React.lazy(() => import('views/app-views/pages/payment/status')),
    },
 
    {
        key: 'payment.success.backend',
        path: '/payment/success',
        component: React.lazy(() => import('views/app-views/pages/payment/success')),
    },
    {
        key: 'payment.cancel.backend',
        path: '/payment/cancel',
        component: React.lazy(() => import('views/app-views/pages/payment/cancel')),
    },
    {
        key: 'payment.status.backend',
        path: '/payment/status',
        component: React.lazy(() => import('views/app-views/pages/payment/status')),
    },
    {
        key: 'payment.debug',
        path: '/app/payment/debug',
        component: React.lazy(() => import('views/app-views/pages/payment/debug')),
    },
    {
        key: 'payment.debug.public',
        path: '/payment/debug',
        component: React.lazy(() => import('views/app-views/pages/payment/debug')),
    },
    {
        key: 'payment.test-route.public',
        path: '/payment/test-route',
        component: React.lazy(() => import('views/app-views/pages/payment/test-route')),
    },
    {
        key: 'payment.direct-test',
        path: '/payment/direct-test',
        component: React.lazy(() => import('views/app-views/pages/payment/direct-test')),
    },
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'login-1',
        path: `${AUTH_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    },
    {
        key: 'login-2',
        path: `${AUTH_PREFIX_PATH}/login-2`,
        component: React.lazy(() => import('views/auth-views/authentication/login-2')),
    },
    {
        key: 'register-1',
        path: `${AUTH_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'terms-and-conditions',
        path: `${APP_PREFIX_PATH}/terms-and-conditions`,
        component: React.lazy(() => import('views/pages/TermsAndConditions')),
    },
    // {
    //     key: 'register-2',
    //     path: `${AUTH_PREFIX_PATH}/register-2`,
    //     component: React.lazy(() => import('views/auth-views/authentication/register-2')),
    // },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'reset-password',
        path: `${AUTH_PREFIX_PATH}/reset-password`,
        component: React.lazy(() => import('views/auth-views/authentication/reset-password')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'error-page-1',
        path: `${AUTH_PREFIX_PATH}/error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    },
    {
        key: 'error-page-2',
        path: `${AUTH_PREFIX_PATH}/error-page-2`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    },
    {
        key: 'about-1',
        path: `${APP_PREFIX_PATH}/about`,
        component: React.lazy(() => import('views/app-views/info/about')),
    },
    {
        key: 'contact-1',
        path: `${APP_PREFIX_PATH}/contact`,
        component: React.lazy(() => import('views/app-views/info/contact')),
    },
    {
        key: 'help-1',
        path: `${APP_PREFIX_PATH}/help`,
        component: React.lazy(() => import('views/app-views/info/help')),
    },
]

export const protectedRoutes = [
    {
        key: 'home',
        path: `${APP_PREFIX_PATH}/home`,
        component: React.lazy(() => import('views/app-views/home')),
    },
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'dashboards-data',
        path: `${APP_PREFIX_PATH}/data`,
        component: React.lazy(() => import('views/app-views/data')),
        meta: { premiumRequired: false },
    },
    {
        key: 'dashboards.search',
        path: `${APP_PREFIX_PATH}/search`,
        component: React.lazy(() => import('views/app-views/search')),
    },
    {
        key: 'dashboards.knowledgeBase',
        path: `${APP_PREFIX_PATH}/kb`,
        component: React.lazy(() => import('views/app-views/knowledgeBase')),
    },
    {
        key: 'dashboards.agent',
        path: `${APP_PREFIX_PATH}/agent`,
        component: React.lazy(() => import('views/app-views/agent')),
    },
    {
        key: 'dashboards.chat-agent',
        path: `${APP_PREFIX_PATH}/chat-agent`,
        component: React.lazy(() => import('views/app-views/chat-agent')),
    },
    {
        key: 'dashboards.accesscontrol',
        path: `${APP_PREFIX_PATH}/accesscontrol`,
        component: React.lazy(() => import('views/app-views/accesscontrol')),
        meta: { roles: ['Admin'], premiumRequired: true },
    },
    {
        key: 'dashboards.document_approval',
        path: `${APP_PREFIX_PATH}/document_approval`,
        component: React.lazy(() => import('views/app-views/document_approval')),
        meta: { roles: ['Admin','Checker','Maker'], premiumRequired: true },
    },
    {
        key: 'dashboards.voice-agent-approval',
        path: `${APP_PREFIX_PATH}/voice-agent-approval`,
        component: React.lazy(() => import('views/app-views/voice-agent-approval')),
        meta: { roles: ['Admin','Checker', 'Maker'], premiumRequired: true },
    },
    {
        key: 'dashboards.chat-agent-approval',
        path: `${APP_PREFIX_PATH}/chat-agent-approval`,
        component: React.lazy(() => import('views/app-views/chat-agent-approval')),
        meta: { roles: ['Admin', 'Checker', 'Maker'], premiumRequired: true },
    },
    {
        key: 'dashboards.tool-approval',
        path: `${APP_PREFIX_PATH}/tool-approval`,
        component: React.lazy(() => import('views/app-views/tool-approval')),
        meta: { roles: ['Admin', 'Checker', 'Maker'], premiumRequired: false },
    },
    {
        key: 'dashboards.audit-logs',
        path: `${APP_PREFIX_PATH}/audit-logs`,
        component: React.lazy(() => import('views/app-views/audit-logs')),
        meta: { premiumRequired: true },
    },
    {
        key: 'dashboard.analytic',
        path: `${APP_PREFIX_PATH}/dashboards/analytic`,
        component: React.lazy(() => import('views/app-views/dashboards/analytic')),
    },

    {
        key: 'login-1',
        path: `${APP_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'login-2',
        path: `${APP_PREFIX_PATH}/login-2`,
        component: React.lazy(() => import('views/auth-views/authentication/login-2')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'register-1',
        path: `${APP_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'register-2',
        path: `${APP_PREFIX_PATH}/register-2`,
        component: React.lazy(() => import('views/auth-views/authentication/register-2')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'forgot-password',
        path: `${APP_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'error-page-1',
        path: `${APP_PREFIX_PATH}/error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'error-page-2',
        path: `${APP_PREFIX_PATH}/error-page-2`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'pages.profile',
        path: `${APP_PREFIX_PATH}/pages/profile`,
        component: React.lazy(() => import('views/app-views/pages/profile')),
    },
    {
        key: 'pages.pricing',
        path: `${APP_PREFIX_PATH}/pages/pricing`,
        component: React.lazy(() => import('views/app-views/pages/pricing')),
        meta: { roles: ['Admin'] },
    },
    // Individual Payment Routes - Admin only access
    {
        key: 'payment.subscription-overview',
        path: `${APP_PREFIX_PATH}/payment/subscription-overview`,
        component: React.lazy(() => import('views/app-views/pages/payment/subscription-overview')),
        meta: { roles: ['Admin'] },
    },
    {
        key: 'payment.dashboard',
        path: `${APP_PREFIX_PATH}/payment/dashboard`,
        component: React.lazy(() => import('views/app-views/pages/payment/dashboard')),
        meta: { roles: ['Admin'], premiumRequired: true },
    },
    {
        key: 'payment.history',
        path: `${APP_PREFIX_PATH}/payment/history`,
        component: React.lazy(() => import('views/app-views/pages/payment/history')),
        meta: { roles: ['Admin'] },
    },
    // Main payment management route - Admin only
    {
        key: 'payment.management',
        path: `${APP_PREFIX_PATH}/payment`,
        component: React.lazy(() => import('views/app-views/pages/payment')),
        meta: { roles: ['Admin'] },
    },
    // Payment debug tool - Temporarily accessible to all authenticated users
    {
        key: 'payment.debug',
        path: `${APP_PREFIX_PATH}/payment/debug`,
        component: React.lazy(() => import('views/app-views/pages/payment/debug')),
        // meta: { roles: ['Admin'] }, // Temporarily removed for debugging
    },
    // Payment test route - Temporarily accessible to all authenticated users
    {
        key: 'payment.test-route',
        path: `${APP_PREFIX_PATH}/payment/test-route`,
        component: React.lazy(() => import('views/app-views/pages/payment/test-route')),
        // meta: { roles: ['Admin'] }, // Temporarily removed for debugging
    },
    {
        key: 'add-tool',
        path: `${APP_PREFIX_PATH}/add-tool`,
        component: React.lazy(() => import('views/app-views/add-tool')),
    },
    {
        key: 'custom-tools',
        path: `${APP_PREFIX_PATH}/custom-tools`,
        component: React.lazy(() => import('views/app-views/custom-tools')),
        meta: { premiumRequired: true },
    },
    {
        key: 'custom-tools-create',
        path: `${APP_PREFIX_PATH}/custom-tools/create`,
        component: React.lazy(() => import('views/app-views/custom-tools/CustomToolForm')),
        meta: { premiumRequired: true },
    },
    {
        key: 'custom-tools-edit',
        path: `${APP_PREFIX_PATH}/custom-tools/edit/:id`,
        component: React.lazy(() => import('views/app-views/custom-tools/CustomToolForm')),
        meta: { premiumRequired: true },
    },
    {
        key: 'custom-tools-submissions',
        path: `${APP_PREFIX_PATH}/custom-tools/submissions`,
        component: React.lazy(() => import('views/app-views/custom-tools/SubmissionsViewer')),
        meta: { premiumRequired: true },
    },
    {
        key: 'vlm-dev-portal',
        path: `${APP_PREFIX_PATH}/vlm-dev-portal/*`,
        component: React.lazy(() => import('views/app-views/vlm-dev-portal')),
    },
    {
        key: 'vlm-nexus',
        path: `${APP_PREFIX_PATH}/vlm-nexus`,
        component: React.lazy(() => import('views/app-views/vlm-nexus')),
    },
    {
        key: 'dashboards.agent-testing',
        path: `${APP_PREFIX_PATH}/agent-testing`,
        component: React.lazy(() => import('views/app-views/agent-testing')),
        meta: { roles: ['Admin', 'Checker', 'Maker'] },
    },
    {
        key: 'dashboards.agent-testing.analytics',
        path: `${APP_PREFIX_PATH}/agent-testing/analytics`,
        component: React.lazy(() => import('views/app-views/agent-testing/TestAnalytics/Main')),
        meta: { roles: ['Admin', 'Checker', 'Maker'] },
    },
    {
        key: 'dashboards.agent-testing.analytics.params',
        path: `${APP_PREFIX_PATH}/analytics/:agentId/:runId`,
        component: React.lazy(() => import('views/app-views/agent-testing/TestAnalytics/Main')),
        meta: { roles: ['Admin', 'Checker', 'Maker'] },
    },
    {
        key: 'dashboards.agent-testing.loading',
        path: `${APP_PREFIX_PATH}/agent-testing/loading`,
        component: React.lazy(() => import('views/app-views/agent-testing/LiveTestReports/TestLoadingPage')),
        meta: { roles: ['Admin', 'Checker', 'Maker'] },
    },
    {
        key: 'dashboards.agent-testing.live-reports',
        path: `${APP_PREFIX_PATH}/agent-testing/live-reports/:runId`,
        component: React.lazy(() => import('views/app-views/agent-testing/LiveTestReports/LiveTestReports')),
        meta: { roles: ['Admin', 'Checker', 'Maker'] },
    },

]